import PropTypes from 'prop-types'
import Button from '@/shared/components/UI/Button'
import CheckCircleIcon from '@/shared/icons/CheckCircleIcon'

const BulletItem = ({ text }) => (
  <li className="flex items-center gap-v3-xs">
    <CheckCircleIcon className="text-v3-green-dark w-5 h-5 flex-shrink-0" />
    <span className="text-v3-black-secondary text-v3-h9 font-inter-variable">{text}</span>
  </li>
)

BulletItem.propTypes = {
  text: PropTypes.string.isRequired,
}

const StepTiming = ({ downgradeInsights, onPause, onLeave, isPauseLoading, isCancelLoading }) => {
  const savings = downgradeInsights?.tier?.price ? downgradeInsights.tier.price - 5 : 94

  return (
    <div className="flex flex-col items-center gap-v3-lg w-full text-center">
      <div className="w-full rounded-v3-lg border-2 border-v3-purple-primary bg-v3-purple-bg p-v3-md flex flex-col items-center gap-v3-sm max-w-[80%] mx-auto">
        <span className="text-4xl">☕</span>

        <div className="flex flex-col gap-v3-xs">
          <h3 className="text-v3-h4 font-bold text-v3-black-max">
            Take a break. Your setup will be here when you return
          </h3>
          <p className="text-v3-black-secondary text-v3-h9 font-inter-variable">
            Pause for just $5/mo. Everything preserved. Agents, conversations, integrations.
          </p>
        </div>

        <ul className="inline-flex flex-col text-left gap-v3-xs">
          <BulletItem text="Your chatbots stay trained and ready" />
          <BulletItem text="All integrations remain connected" />
          <BulletItem text="Resume whenever you're ready — one click" />
          <BulletItem text={`Save $${savings}/mo while you're away`} />
        </ul>

        <Button
          variant="primary"
          size="lg"
          label="Pause my account ($5/mo)"
          onClick={onPause}
          loading={isPauseLoading}
          loadingLabel="Pausing..."
        />
      </div>

      <Button
        variant="transparent"
        label="I'd prefer to cancel completely"
        onClick={onLeave}
        loading={isCancelLoading}
        loadingLabel="Cancelling..."
        disabled={isPauseLoading}
      />
    </div>
  )
}

StepTiming.propTypes = {
  downgradeInsights: PropTypes.shape({
    tier: PropTypes.shape({
      price: PropTypes.number,
    }),
  }),
  onPause: PropTypes.func.isRequired,
  onLeave: PropTypes.func.isRequired,
  isPauseLoading: PropTypes.bool,
  isCancelLoading: PropTypes.bool,
}

StepTiming.defaultProps = {
  downgradeInsights: null,
  isPauseLoading: false,
  isCancelLoading: false,
}

export default StepTiming
